__turbopack_context__.v({
  "badge": "tC3bGW_badge",
  "badgeLogo": "tC3bGW_badgeLogo",
  "container": "tC3bGW_container",
  "containerFillParent": "tC3bGW_containerFillParent",
  "qrCode": "tC3bGW_qrCode",
  "qrCodeFillParent": "tC3bGW_qrCodeFillParent",
});
